import {Observable} from "rxjs";
import {Injectable} from '@angular/core';
import {InterpolatableTranslationObject, TranslateService} from '@ngx-translate/core';
import {I18nMessage} from '@shared/api/model/i18n';

@Injectable({
  providedIn: 'root'
})
export class MessageTranslateService {

  public static readonly EN_LANG = 'en';

  constructor(private translateService: TranslateService) {
  }

  public initLanguages(): Observable<InterpolatableTranslationObject> {
    if (!this.translateService.langs?.length) {
      this.translateService.addLangs([MessageTranslateService.EN_LANG, 'fr']);
    }
    if (!this.translateService.defaultLang) {
      this.translateService.setDefaultLang(MessageTranslateService.EN_LANG);
    }

    return this.translateService.use(this.translateService.currentLang ?? MessageTranslateService.EN_LANG);
  }


  public get translations() {
    return this.translateService.translations;
  }

  public get currentLang() {
    return this.translateService.currentLang;
  }

  public instant(key: string | I18nMessage, params?: Object): string | any {
    if (typeof key === 'string') {
      return this.translateService.instant(key, params);
    } else if (this.isI18nMessage(key)) {
      if (params == null) {
        const message = this.transformToUnnestedI18nMessage(key);
        return this.translateService.instant(message.messageKey, message.parameters);
      } else {
        throw new Error('Cannot supply extra params "' + JSON.stringify(params) +'" when passing in I18nMessage');
      }
    } else {
      throw new Error('Error Invalid parameter: accepting I18nMessage or a string with optional parameters');
    }
  }

  public transformToUnnestedI18nMessage(message: I18nMessage): I18nMessage {
    let params;
    if (message && message.parameters && Object.keys(message.parameters).length) {
      params = {};
      for (const paramKey in message.parameters) {
        let paramValue = message.parameters[paramKey];
        if (this.isI18nMessage(paramValue)) {
          const t = this.transformToUnnestedI18nMessage(paramValue);
          paramValue = this.translateService.instant(t.messageKey, t.parameters)
        }
        params[paramKey] = paramValue;
      }
    }

    return {messageKey: message.messageKey, ...params != null && {parameters: params}};
  }

  private isI18nMessage(value: any): value is I18nMessage {
    return value instanceof I18nMessage || value['messageKey'] !== undefined;
  }
}
